import './chevron.css';

const chevron = ({ onClick, disabled = false, isUp = false }) => {
	return (
		<span
			className={`chevron ${isUp ? 'up' : 'down'} ${
				disabled ? 'disabled' : ''
			}`}
			onClick={disabled ? '' : onClick}
		/>
	);
};

export default chevron;
